import { useAuth } from '../hooks/useAuth.js';

const ROLE_LABELS = {
  team_leader: 'Team Leader',
  agent: 'Agent',
  isa: 'ISA',
  super_admin: 'Super Admin',
};

export default function Profile() {
  const { user } = useAuth();
  const name = user?.name || '—';
  const email = user?.email || '—';
  const role = ROLE_LABELS[user?.role] || user?.role || '—';

  return (
    <div className="max-w-2xl">
      <h1 className="page-title mb-1">My Profile</h1>
      <p className="text-sm text-text-secondary mb-6">
        Your account details. Editing will land in a future update.
      </p>

      <div className="card p-6 space-y-4">
        <Row label="Name" value={name} />
        <Row label="Email" value={email} />
        <Row label="Role" value={role} />
      </div>
    </div>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex items-baseline gap-6">
      <div className="w-28 text-sm text-text-secondary shrink-0">{label}</div>
      <div className="text-sm text-text-primary font-medium">{value}</div>
    </div>
  );
}
